import { Component, OnInit } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-road-map',
  templateUrl: './road-map.component.html',
  styleUrls: ['./road-map.component.scss']
})
export class RoadMapComponent implements OnInit {
  constructor(private _lightbox: Lightbox) {}

  ngOnInit(): void {}

  click() {
    this._lightbox.open(
      [
        {
          src: '/assets/Ipaam-Poster-Road-Map-Edit-2.jpg',
          caption: 'نقشه راه',
          thumb: '/assets/Ipaam-Poster-Road-Map-Edit-2.jpg'
        }
      ],
      0
    );
  }
}
